// Hook personalizado para obtener métricas de preferencias sexuales
// Agrupa usuarios por combinación de sexo y preferencia sexual

import { useState, useEffect } from 'react';
import { supabase } from '../config/supabase';

export function useSexualPreferences() {
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);
  const [error, setError] = useState(null);

  const fetchPreferences = async () => {
    try {
      setIsLoading(true);
      setIsError(false);
      setError(null);

      const { data: preferencesData, error: fetchError } = await supabase
        .from('profiles')
        .select('sex, sex_pref')
        .not('sex', 'is', null)
        .not('sex_pref', 'is', null);

      if (fetchError) throw fetchError;

      // Agrupar y contar por combinación
      const grouped = {
        hombre_hombres: 0,
        hombre_mujeres: 0,
        hombre_ambos: 0,
        mujer_hombres: 0,
        mujer_mujeres: 0,
        mujer_ambos: 0,
      };

      preferencesData.forEach(profile => {
        const { sex, sex_pref } = profile;
        
        // sex: 1=Mujer, 2=Hombre
        // sex_pref: 0=Ambos, 1=Mujeres, 2=Hombres
        if (sex === 2) { // Hombre
          if (sex_pref === 2) grouped.hombre_hombres++;
          else if (sex_pref === 1) grouped.hombre_mujeres++;
          else if (sex_pref === 0) grouped.hombre_ambos++;
        } else if (sex === 1) { // Mujer
          if (sex_pref === 2) grouped.mujer_hombres++;
          else if (sex_pref === 1) grouped.mujer_mujeres++;
          else if (sex_pref === 0) grouped.mujer_ambos++;
        }
      });

      setData(grouped);
    } catch (err) {
      console.error('Error fetching sexual preferences:', err);
      setIsError(true);
      setError(err);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchPreferences();
  }, []);

  return {
    data,
    isLoading,
    isError,
    error,
    refetch: fetchPreferences,
  };
}
